// Filename: public/common.js 

import {session} from 'wix-storage';

export function setLectureType(lectureType) {
    session.setItem("lectureType", lectureType);
    let num = 0;

    switch (lectureType) {
    case 'Frontend':
        num = 1;
        break;
    case 'Backend':
        num = 2;
        break;
    case 'Culture':
        num = 3;
        break;
    case 'Mobile':
        num = 4;
        break;
    }
    session.setItem("categoryIndex", num);
}

export function getLectureType() {
    return session.getItem("lectureType"); 
}

export function getCategoryIndex() {
    return session.getItem("categoryIndex"); 
}
